import React from "react"
import Spinner from "react-spinkit"
import { Table } from "react-bootstrap"
import { formatCurrency } from "../../../lib/utils"
import CaptionTable from "../../fragments/CaptionTable"

export default class RepaymentSummary extends React.Component {

  renderThs = () => <tr>
    <th>Upfront payment</th>

    <th>Regular payment</th>

    <th>Total Repaid</th>
  </tr>

  getData = () => {

    const { allUpfrontPayment, allTotalRepayment, running } = this.props,

    diff = Number(allUpfrontPayment) <= Number(allTotalRepayment)
      ? allTotalRepayment - allUpfrontPayment : null

    return <tr>

      <td>{ formatCurrency(allUpfrontPayment) }</td>

      <td>{ running ? '...' : formatCurrency(diff) }</td>

      <td>{ running ? <Spinner name="ball-beat" /> : formatCurrency(allTotalRepayment) }</td>
    </tr>
  }

  render() {

    return (
      <Table striped condensed hover responsive>

        <CaptionTable text='Repayments' />

        <tbody>
          { this.renderThs() }
          { this.getData() }
        </tbody>
      </Table>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Buckets/RepaymentSummary.js